/* -------------------------------------------------------------------------------------------------
   <auto-generated>
      This code was generated from a T4 template.

      DO NOT ALTER!
      Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.

      Template Authors: Leonard Lewis
   </auto-generated>
   ------------------------------------------------------------------------------------------------- */

/// <summary>
///   Core.NotificationType_
///   This is an auto-generated enumeration of the SWFC_Learning.Core.NotificationType domain table...
/// </summary>
import { IDomainModel } from './domain-model.interface';

export enum NotificationType_ {
   /// <summary>
   ///   Achievement (achieve)
   /// </summary>
   Achievement = 1,
   /// <summary>
   ///   FAQ (faq)
   /// </summary>
   FAQ = 2,
   /// <summary>
   ///   Freebie Earned (free)
   /// </summary>
   FreebieEarned = 3,
   /// <summary>
   ///   First Mentor Meeting (mentor1)
   /// </summary>
   FirstMentorMeeting = 4
}

export const NotificationTypes: NotificationType[] = [
   {
      code: NotificationType_.Achievement,
      literal: 'Achievement',
      description: 'Achievement',
      shortDescription: 'achieve',
      listPriority: 0,

      scheduleTypeCode: 0,

      scheduled: null,

      scheduledDuration: null,

      typeName: "NotificationType"
   },
   {
      code: NotificationType_.FAQ,
      literal: 'FAQ',
      description: 'FAQ',
      shortDescription: 'faq',
      listPriority: 0,

      scheduleTypeCode: 0,

      scheduled: null,

      scheduledDuration: null,

      typeName: "NotificationType"
   },
   {
      code: NotificationType_.FreebieEarned,
      literal: 'FreebieEarned',
      description: 'Freebie Earned',
      shortDescription: 'free',
      listPriority: 0,

      scheduleTypeCode: 0,

      scheduled: null,

      scheduledDuration: null,

      typeName: "NotificationType"
   },
   {
      code: NotificationType_.FirstMentorMeeting,
      literal: 'FirstMentorMeeting',
      description: 'First Mentor Meeting',
      shortDescription: 'mentor1',
      listPriority: 0,

      scheduleTypeCode: 0,

      scheduled: null,

      scheduledDuration: null,

      typeName: "NotificationType"
   }
]

export class NotificationType implements IDomainModel {
   code: NotificationType_
   literal: string
   description: string
   shortDescription: string
   listPriority: number

   scheduleTypeCode: number

   scheduled: string

   scheduledDuration: number

   typeName: string

   static toDomainModel(code: NotificationType_): NotificationType {
      return NotificationTypes.find(d => d.code === code)
   }
}
